import ITranslation from './translation'

export class Translator<T extends ITranslation> {
    public languages = new Array<T>()
    public language!: T

    public setLanguage(code: string) {
        const lang = this.languages.find(x => x.infos.code == code)
        if (!lang) throw 'Default language not found in collection.'
        this.language = lang
    }
    constructor(code: string, languages: Array<T>) {
        this.languages = languages
        this.setLanguage(code)
    }
}

export default function translator<T extends ITranslation>(code: string, ...languages: Array<T>) {
    return {
        install(Vue: any) {
            Vue.prototype.$translator = Vue.observable(new Translator(code, languages))
        }
    }
}
